/* 
    企业认证列表
 */
 <template>
  <div class="companyLists">
    <Row
      :gutter="10"
      v-if="companyAuthLists && companyAuthLists.length > 0"
      type="flex"
      justify="start"
      align="top"
    >
      <Col span="8" v-for="(item, index) in companyAuthLists" :key="index">
      <div @click="checkDetails(item)">
          <Card>
          <p class="name">{{item.companyName}}</p>
          <p class="name">{{item.regCode}}</p>
          <Tag v-if="item.status === 1" class="tag-list" color="default">认证中</Tag>
          <Tag v-if="item.status === 2" class="tag-list" color="warning">认证成功</Tag>
          <Tag v-if="item.status === 3" class="tag-list" color="error">被驳回</Tag>
          <i v-if="item.status !== 1" @click.stop="deletecompanyHandle(item)" class="iconfont icon-trash"></i>
        </Card>
      </div>
        
      </Col>
      <Col span="8">
        <div @click="addAuthHandle">
          <Card>
            <i class="iconfont icon-plus-m"></i>
          </Card>
          <p class="addAuth">新增企业认证</p>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    companyAuthLists: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    addAuthHandle() {
      this.$emit("addAuth");
    },
    /* 查看详情 */
    checkDetails(item) {
        this.$emit('details', item)
    },
    /* 删除 */
    deletecompanyHandle(item) {
      this.$emit('deleteCompany', item)
    }
  }
};
</script>

<style lang="scss">
.companyLists {
  .ivu-col {
    margin-bottom: 10px;
  }
  .ivu-card {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    position: re;
    cursor: pointer;
    .ivu-card-body {
      border: none !important;
      padding: 55px 20px !important;
      p {
        font-size: 16px;
        font-weight: 400;
      }
      .name {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      .icon-trash {
        position: absolute;
        bottom: 10px;
        right: 10px;
        font-size: 16px;
        color: #787878;
        &:hover {
          opacity: 0.8;
          color:#ff9900;
        }
      }
      .icon-plus-m {
        font-size: 35px;
        color: #787878;
      }
      .tag-list {
        position: absolute;
        top: -10px;
        left: 3px;
      }
    }
  }
  .addAuth {
    margin-top: 20px;
    font-size: 16px;
  }
}
</style>


 